import React from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "./pessoasSetoresExecutantesCadastros.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import {
  getPessoaSetorExecutanteById,
  getPessoaSetorExecutanteUpdate,
  getPessoasSetoresExecutantesCadastro,
} from "../../services/api_cadastro_pessoas_setores_executantes";
import { getSetoresExecutantes } from "../../services/api_setores_executantes";
import { getPessoas } from "../../services/api_pessoas";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const PessoasSetoresExecutantesRegister = () => {
  const location = useLocation();
  const id = location.state?.id;
  const idSetor = location.state?.idSetor;
  const nomeSetor = location.state?.nomeSetor;
  const [id_pessoa, setPessoa] = useState("");
  const [pessoa, setPessoas] = useState([]);
  const [setoresExecutantes, setSetoresExecutantes] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  //console.log(idSetor);
  //console.log(nomeSetor);

  useEffect(() => {
    const fetchPessoasSetoresExecutantes = async () => {
      try {
        const response = await getPessoaSetorExecutanteById(id);
        //console.log(response);
        const pessoas_setores_executantes = response.data.PessoaSetorExecutante; // Corrigido para acessar response.data.empresa
        if (pessoas_setores_executantes) {
          setPessoa(pessoas_setores_executantes.id_pessoa || "");
        } else {
          console.error("Dados não encontrados na resposta:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados da unidade:", error);
      }
    };

    if (id) {
      fetchPessoasSetoresExecutantes();
    }
  }, [id]);

  useEffect(() => {
    const fetchPessoa = async () => {
      try {
        const response = await getPessoas();
        //console.log(response);

        if (response) {
          const pessoasAtivas = response.data.pessoas.filter(
            (pessoa) => pessoa.deleted_at == null
          );
          setPessoas(pessoasAtivas);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchPessoa();
    const interval = setInterval(()=>{
      fetchPessoa()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchSetorExecutante = async () => {
      try {
        const response = await getSetoresExecutantes();
        //console.log(response);

        if (response) {
          const setoresExecutantesAtivos =
            response.data.SetoresExecutantes.filter(
              (setorExecutante) => setorExecutante.deleted_at == null
            );
          setSetoresExecutantes(setoresExecutantesAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchSetorExecutante();
    const interval = setInterval(()=>{
      fetchSetorExecutante()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!id_pessoa) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento do campo Pessoa é obrigatório.",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getPessoasSetoresExecutantesCadastro(body);
      //console.log(response);
      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao fazer cadastro:", response);
      }
    } catch (error) {
      console.error("Erro ao fazer cadastro:", error);
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getPessoaSetorExecutanteUpdate(id, body);
      //console.log(response);
      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        id_pessoa,
        id_setor_executante: idSetor,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Pessoa no Setor Executante" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formAplicacao">
                  <Form.Label>Pessoa</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_pessoa}
                    onChange={(e) => setPessoa(e.target.value)}
                  >
                    <option value="">Selecione</option>
                    {pessoa &&
                      pessoa.map((id_pessoa) => (
                        <option key={id_pessoa.id} value={id_pessoa.id}>
                          {id_pessoa.nome}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default PessoasSetoresExecutantesRegister;
